<script>
  // # # # # # # # # # # # # #
  //
  //  404 page
  //
  // # # # # # # # # # # # # #

  // *** IMPORT
  import { onMount } from "svelte";

  // *** ON MOUNT
  onMount(async () => {
    window.scrollTo(0, 0);
  });
</script>

<style lang="scss">
  @import "../_variables.scss";

  .error {
    line-height: 1.3em;
    font-size: $font-size-large;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    margin-top: $top-space;

    a {
      color: currentColor;

      @include normal-hover-state;
    }
  }
</style>

<svelte:head>
  <title>404 | COMPLETE WORKS</title>
</svelte:head>

<div class="error">
  <p>
    404
    <br />
    Page not found
    <br />
    <a href="/">Return to frontpage.</a>
  </p>
</div>
